import { Reducer } from "redux";

import { NPPESDataResponse } from "../models/Api/PhysicianDetails";
import { nppesInitialRecord } from "../constants/PhysicianDetails";
import { GetOrderingNPPESDataActionDispatchTypes } from "../constants/Nppes";
import { OrderingNppesSearchDispatchTypes } from "../models/DispatchTypes/Nppes";

const initialState: NPPESDataResponse = {
  loading: true,
  response: nppesInitialRecord
};

const NppesOrderingDetailsListReducer: Reducer<
NPPESDataResponse,
OrderingNppesSearchDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetOrderingNPPESDataActionDispatchTypes.GET_ORDERING_NPPES_DATA_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetOrderingNPPESDataActionDispatchTypes.GET_ORDERING_NPPES_DATA_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetOrderingNPPESDataActionDispatchTypes.GET_ORDERING_NPPES_DATA_RESET: {
      return initialState;
    }
    case GetOrderingNPPESDataActionDispatchTypes.GET_ORDERING_NPPES_DATA_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default NppesOrderingDetailsListReducer;
